import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { USER_URL } from '../shared/src';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private readonly USER_API = `${USER_URL}/auth`;
  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandlerService
  ) { }

  public generateOtp(email: string): Observable<string> {
    return this.http.post<string>(`${this.USER_API}/generateOtp`, email);
  }
  public login(loginData: string): Observable<string> {
    return this.http
      .post<string>(`${this.USER_API}/login-with-otp`, loginData)
      .pipe(catchError(this.errorHandler.handleError));
  }
  public userLogin(loginData: string): Observable<string> {
    return this.http
      .post<string>(`${this.USER_API}/login`, loginData)
      .pipe(catchError(this.errorHandler.handleError));
  }

  // Check if user is logged in
  isLoggedIn(): boolean {
    return !!localStorage.getItem('auth-token');
  }

  public updateFCMToken(fcmToken: string): Observable<string> {
    const fcmTokenData = {
      token: fcmToken,
      deviceInfo: 'WEB',
    };
    if (fcmToken) {
      localStorage.setItem('fcm_token', fcmToken);
    }
    return this.http
      .post<string>(`${USER_URL}/userLoginLogs/save`, fcmTokenData)
      .pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Unlinks only this device for the signed-in user.
   * Other devices for this user, and other users, are left registered.
   */
  public clearNotificationDevices(): Observable<string> {
    const token = localStorage.getItem('fcm_token');
    if (!token) {
      return of('success');
    }
    return this.http
      .post<string>(`${USER_URL}/userLoginLogs/logout`, { token })
      .pipe(catchError(this.errorHandler.handleError));
  }
}
